var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/setting"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.63a3.8 3.8 0 01-1.88-.46L4.62 19c-2.24-1.509-2.38-1.737-2.38-4.109V9.11c0-2.37.13-2.6 2.33-4.09l5.54-3.199a4.071 4.071 0 013.75 0l5.52 3.18c2.24 1.51 2.38 1.74 2.38 4.11v5.77c0 2.37-.13 2.6-2.33 4.09l-5.54 3.2a3.86 3.86 0 01-1.89.459zm0-19.76a2.289 2.289 0 00-1.12.25L5.38 6.3C3.75 7.4 3.75 7.4 3.75 9.11v5.77c0 1.71 0 1.71 1.67 2.84l5.46 3.15a2.609 2.609 0 002.25 0l5.5-3.18c1.62-1.1 1.62-1.1 1.62-2.81V9.11c0-1.71 0-1.71-1.67-2.84l-5.46-3.15A2.289 2.289 0 0012 2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M12 15.75A3.75 3.75 0 1115.75 12 3.751 3.751 0 0112 15.75zm0-6A2.25 2.25 0 1014.25 12 2.253 2.253 0 0012 9.75z"
  }))));
}
export default SvgVuesaxOutlineSetting;